<mat-dialog-content class="address-dialog-content">

  <!-- =====================================================
         HEADER
         ===================================================== -->

  <header class="address-dialog-header">

    <div class="address-dialog-heading">

      <span class="address-dialog-eyebrow">
        ENVÍO A DOMICILIO
      </span>

      <h2>
        Mis direcciones
      </h2>

    </div>

    <button class="address-dialog-close" mat-dialog-close type="button" aria-label="Cerrar">

      <mat-icon>
        close
      </mat-icon>

    </button>

  </header>


  <!-- =====================================================
         CONTENIDO
         ===================================================== -->

  <div class="address-dialog-body">

    <!-- TOOLBAR -->

    <div class="address-toolbar">

      <p class="address-toolbar-text">
        Selecciona la dirección a la que quieres recibir tu pedido.
      </p>

      <button class="address-add-button" mat-raised-button type="button" (click)="openNewAddress()">

        <mat-icon>
          add
        </mat-icon>

        Agregar dirección

      </button>

    </div>


    <!-- =================================================
             LOADING
             ================================================= -->

    <div class="address-loading" *ngIf="isLoading">

      Cargando tus direcciones…

    </div>


    <!-- =================================================
             SIN DIRECCIONES
             ================================================= -->

    <section class="address-empty" *ngIf="!isLoading && addresses.length === 0">

      <img src="assets/img/nina_no_direcciones.png" alt="Sin direcciones guardadas">

      <span class="address-empty-eyebrow">
        ENVÍO A DOMICILIO
      </span>

      <h3>
        Aún no tienes direcciones guardadas
      </h3>

      <p>
        Agrega una dirección para poder usarla en tu pedido.
      </p>

      <button class="address-add-button address-empty-button" mat-raised-button type="button"
        (click)="openNewAddress()">

        <mat-icon>
          add
        </mat-icon>

        Agregar mi primera dirección

      </button>

    </section>


    <!-- =================================================
             DIRECCIONES
             ================================================= -->

    <section class="address-layout" *ngIf="!isLoading && addresses.length > 0">


      <!-- =================================================
                 LISTA
                 ================================================= -->

      <div class="address-list" aria-label="Direcciones guardadas">

        <article *ngFor="let address of addresses" class="address-card"
          [class.address-card--selected]="isSelected(address)" role="button" tabindex="0"
          [attr.aria-pressed]="isSelected(address)" (click)="selectAddress(address)"
          (keydown)="onAddressKeydown($event, address)">


          <div class="address-card-icon">

            <mat-icon>
              location_on
            </mat-icon>

          </div>


          <div class="address-card-content">

            <strong>
              {{ address.street }} {{ address.ext_number }}
            </strong>

            <span>
              {{ address.locality?.name || 'Colonia no registrada' }},
              C.P. {{ address.zip_code }}
            </span>

            <span>
              {{ address.municipality?.name || 'Municipio no registrado' }},
              {{ address.state?.name || 'Estado no registrado' }}
            </span>

          </div>


          <div class="address-card-check" *ngIf="isSelected(address)">

            <mat-icon>
              check
            </mat-icon>

          </div>

        </article>

      </div>


      <!-- =================================================
                 DETALLE
                 ================================================= -->

      <aside class="address-detail" *ngIf="selectedAddress; else selectAnAddress">


        <span class="address-detail-eyebrow">
          DETALLES DE LA DIRECCIÓN
        </span>


        <h3>
          {{ selectedAddress.street }}
          {{ selectedAddress.ext_number }}
        </h3>


        <p class="address-detail-location">

          {{ getLocalityLabel(selectedAddress) }}
          {{ selectedAddress.locality?.name || 'No registrada' }},
          {{ selectedAddress.municipality?.name || 'No registrado' }},
          {{ selectedAddress.state?.name || 'No registrado' }}

        </p>


        <div class="address-detail-data">

          <div class="address-detail-row">

            <span>
              Recibe
            </span>

            <strong>
              {{ selectedAddress.receiving_name || 'No registrado' }}
            </strong>

          </div>


          <div class="address-detail-row">
            <span>
              Teléfono
            </span>
            <strong>
              {{ formatPhone(selectedAddress.phone) }}
            </strong>
          </div>
          <div class="address-detail-row" *ngIf="selectedAddress.references">
            <span>
              Referencias
            </span>
            <strong>
              {{ selectedAddress.references }}
            </strong>
          </div>
        </div>
        <button class="address-confirm-button" mat-raised-button type="button" (click)="confirmSelection()">
          Usar esta dirección
        </button>
      </aside>
      <!-- =================================================
                 SIN SELECCIÓN
                 ================================================= -->
      <ng-template #selectAnAddress>
        <aside class="address-detail address-detail-placeholder">
          <div class="address-placeholder-icon">
            <mat-icon>
              touch_app
            </mat-icon>
          </div>
          <p>
            Selecciona una dirección de la lista
            para revisar sus detalles.
          </p>
        </aside>
      </ng-template>
    </section>
  </div>
</mat-dialog-content>